// profcut-4b9d2e63 — src/utils/profilePrivacy.js
//
// HAND-SYNCED MIRROR of functions/utils/profilePrivacy.js (field lists + resolveProfileRead) and of
// profileFieldNames() / fieldWorkerProfileFieldNames() in firestore.rules. Change all three together;
// functions/scripts/testProfilePrivacy.js fails if a field is missing here.
//
// Personal details (birth date, home address, emergency contact, legal name, HR documents, time off)
// live in users/{uid}/private/profile and organizations/{org}/fieldWorkers/{id}/private/profile —
// Owner/Admin/Manager only — not on the main records, which every org member can read.

export const PROFILE_PRIVATE_FIELDS = [
  'legalName', 'birthDate', 'startDate', 'contactDetails',
  'homeAddress1', 'homeAddress2', 'homeCity', 'homeState', 'homeZip', 'homeCountry',
  'emergencyName', 'emergencyRelationship', 'emergencyPhone1', 'emergencyPhone2', 'emergencyEmail',
  'directDepositFormUrl', 'certifications', 'disciplinaryForms', 'timeOffHistory',
  'vacationWeeksAllotted', 'vacationDaysTaken', 'sickDaysTaken', 'personalDaysTaken',
  'undergradDegree', 'mastersDegree', 'doctorateDegree',
];

export const FIELDWORKER_PROFILE_FIELDS = [...PROFILE_PRIVATE_FIELDS, 'notes', 'terminationReason'];

// Transition read: a key that EXISTS on the private record wins (even null / [] — a deliberate clear
// must not fall back to a stale main-record copy); otherwise the main record's value is used. Once
// functions/scripts/moveParentProfile.js has run, main records hold none of these keys.
export const resolveProfileRead = (parentData, privateData, fieldList = PROFILE_PRIVATE_FIELDS) => {
    const out = { ...(parentData || {}) };
    for (const f of fieldList) {
        if (privateData && Object.prototype.hasOwnProperty.call(privateData, f)) out[f] = privateData[f];
    }
    return out;
};
